<template>
  <div>
    <div class="content-header">生徒名：{{ currentBillingStudentName }}</div>
    <div class="content-body">
      <input type="radio" class="body-radio" id="billable" value="billable" v-model="billingDetail.status" />
      <label class="body-radio" for="billable">請求対象</label>
    </div>
    <div class="content-body">
      <input type="radio" class="body-radio" id="unbillable" value="unbillable" v-model="billingDetail.status" />
      <label class="body-radio" for="unbillable">請求対象外</label>
    </div>
  </div>
</template>

<script>
import { basicStudentNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    billingDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentBillingStudentName() {
      if (this.billingDetail) {
        return basicStudentNameIdPresent(this.billingDetail);
      }
      return '';
    },
  },
};
</script>

<style scoped>
.content-header {
  margin-left: 10px;
  margin-bottom: 15px;
}
.content-body {
  margin-left: 10px;
  margin-bottom: 10px;
}
.body-radio {
  margin-right: 5px;
}
</style>
